<template>
    <a  class="h4 align-middle link-dark" @click="show">
        <slot></slot>
    </a>
</template>

<script>

export default {
    props:
        ["modal","values","id","competitionId"]
    ,
    methods:{
        show(){
            this.modal.$refs.modal.showModal=true
            this.modal.$refs.modal.value=this.values
            this.modal.$refs.modal.submissionId=this.id
            this.modal.$refs.modal.competitionId=this.competitionId

        }
    }
    ,
    data: () => ({

    }),
}
</script>

<style scoped>

</style>
